
module.exports =
  misfit:       Symbol 'misfit'
  end:          Symbol 'end'
